import React, { useState, useContext, useEffect } from 'react';
import { Card, Form, Button, Spinner, InputGroup } from 'react-bootstrap';
import { FaEnvelope, FaLock } from 'react-icons/fa';
import { useAuth } from '../../contexts/auth-context/index';
import { useNavigate } from 'react-router-dom';
import { NotificationContext } from '../../contexts/notification-context/index';
import authService from '../../api/authService';
import ButtonSubmit from '../../components/button';

import './index.css';
import { PERFIS } from '../../constants/perfis';

const Login = () => {
  const { login, isAuthenticated, user } = useAuth();
  const { addNotification } = useContext(NotificationContext); 
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect (() => {
    if (isAuthenticated && user) {
      const targetRoute = user.perfilId === PERFIS.AGENDAMENTO ? '/agenda' : '/home';
      navigate(targetRoute);
    }
  }, [isAuthenticated, user, navigate]);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5521972853889?text=Gostaria%20de%20realizar%20meu%20cadastro%20para%20subloca%C3%A7%C3%A3o%20de%20salas%20de%20atendimento.', '_blank'); 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !senha) {
      addNotification('danger', 'Por favor, preencha todos os campos.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      addNotification('danger', 'Por favor, insira um email válido.');
      return;
    }

    setLoading(true);

    try {
      const userData = await authService.login({ email, senha });

      if (userData) {
        login(userData);
        addNotification('success', 'Login realizado com sucesso!');
        navigate(userData.perfilId === PERFIS.AGENDAMENTO ? '/agenda' : '/home');
      } else {
        addNotification('danger', 'Usuário e/ou senha inválidas. Por favor, tente novamente.');
      }
    } catch (err) {
      const errorMessage = err?.message || 'Erro ao realizar login. Por favor, tente novamente.';
      console.log(err);
      addNotification('danger', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card shadow-sm">
        <Card.Body>
          <Card.Title className="mb-4 login-title">Login</Card.Title>

          <Form onSubmit={handleSubmit} className="login-form">
            <Form.Group className="mb-4" controlId="formEmail">
              <Form.Label>E-mail</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FaEnvelope />
                </InputGroup.Text>
                <Form.Control
                  type="email"
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  size="lg"
                />
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formSenha">
              <Form.Label>Senha</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <FaLock />
                </InputGroup.Text>
                <Form.Control
                  type="password"
                  placeholder="Digite sua senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  size="lg"
                />
              </InputGroup>
            </Form.Group>

            <div className="d-grid mb-3">
              <ButtonSubmit type="submit" disabled={loading} size="lg" className={loading ? 'btn-loading' : ''}>
                {loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : 'Entrar'}
              </ButtonSubmit>
            </div>
            <div className="text-center custom-text">
              <span>
                Esqueceu sua senha?{' '}
                <Button
                  variant="link"
                  onClick={() => navigate('/esqueci-senha')}
                  size="sm"
                  style={{ fontSize: '14px', padding: '0' }}
                >
                  Clique aqui
                </Button>
              </span>
              <br />
              <span>
                Não possui cadastro?{' '}
                <Button
                  variant="link"
                  onClick={handleWhatsAppClick}
                  size="sm"
                  style={{ fontSize: '14px', padding: '0' }}
                >
                  Cadastre-se
                </Button>
              </span>
            </div>

          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Login;
